import styled from 'styled-components';

export const OnlineBookingUnavailableMessageContainer = styled.div<{ $compact?: boolean }>`
  color: ${({ theme }) => theme.colors.neutral.primaryNavy};
  font-size: ${({ $compact }) => ($compact ? '16px' : '24px')};
  line-height: 1.5;
  padding: ${({ $compact }) => ($compact ? '16px 0 0' : '50px 10px 10px')};
  text-align: ${({ $compact }) => ($compact ? 'left' : 'center')};

  a {
    color: inherit;
    font-size: ${({ $compact }) => ($compact ? '18px' : '28px')};
    font-weight: 700;
    text-decoration: underline;
    white-space: nowrap;
  }
`;
